import React from 'react';
import { Card, CardContent, Grid, makeStyles } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 280,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: 0,
        boxShadow: "none",
        border: '1px solid #EAEAEA',
        borderRadius: 8,
        '& .MuiCardContent-root': {
            padding: '30px 18px 30px 40px!important',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            cursor: 'pointer',
            height: '100%'
        }
    },
    selectedIcon: {
        width: 20,
        height: 20,
        position: 'absolute',
        top: 30,
        left: 10,
        color: '#008C74'
    },
    couponAppliedBar: {
        backgroundColor: '#008C74',
        width: '100%',
        color: '#CFF8F3',
        fontSize: 10,
        left: 0,
        right: 0,
        padding: '4px 10px',
        position: 'absolute',
        bottom: 0
    },
    expired: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& p': {
            fontSize: 12,
            margin: 0,
            color: '#4F4F4F',
            flex: 1,
            fontWeight: 700,
            '&.green': {
                color: '#40B90E',
                textAlign: 'right',
                fontWeight: 700,
            }
        }
    },
    discountedPrice: {
        color: '#757575',
        fontWeight: 400,
        fontSize: 13,
        position: 'relative',
        marginRight: 5,
        '&::before': {
            content: `''`,
            position: 'absolute',
            zIndex: 1,
            background: '#757575',
            height: 2,
            width: '100%',
            top: 6
        }
    },
    selectedPlan: {
        border: '1px solid #008C74',
    },
    days: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 10,
        '& h4': {
            margin: 0
        },
    },
    circle: {
        width: 16,
        height: 16,
        border: '1px solid #707070',
        borderRadius: '50%',
        position: 'absolute',
        top: 32,
        left: 10,
    },
}));
const PlanView = props => {
    const classes = useStyles();
    const { selectedPlan, plan, planCardClick, getDays } = props;
    console.log(plan.cashDiscount);
    return (
        <Grid item sm={6} xs={12} md={4} onClick={() => planCardClick(plan)}>
            <Card
                className={`${classes.root} ${selectedPlan && selectedPlan._id === plan._id ? classes.selectedPlan : ''}`}>
                <CardContent>
                    {selectedPlan && selectedPlan._id === plan._id ?
                        <CheckCircleIcon className={classes.selectedIcon}/> :
                        <div className={classes.circle}/>}
                    <div className={classes.days}>
                        <h4>{plan.name}</h4>
                        <h4 className="rightAlign">
                            <span className={classes.discountedPrice}>₹{plan.actualPrice}</span> ₹{plan.finalPrice}
                        </h4>
                    </div>
                    <div className={classes.expired}>
                        <p>Valid for {getDays(plan.subscriptionType)} Days</p>
                        <p className="green">You Save <span>₹{plan.cashDiscount.toFixed(2)} ({plan.discount}%)</span>
                        </p>
                    </div>
                    {
                        plan.discountViaCoupon > 0 && <div className={classes.couponAppliedBar}>
                            Coupon Applied! You Save extra {plan.discountViaCoupon}₹
                        </div>
                    }
                </CardContent>
            </Card>
        </Grid>
    );
};
export default PlanView;
